// extracted by mini-css-extract-plugin
export default {"container":"specialities_container__RBNz5","specialitiesAbout":"specialities_specialitiesAbout__MFeQ4"};